/**
 * @module  experience/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Widgets
import { WidgetsModule } from '@support/shared/widgets/widgets.module';

// Components
import { ServiceBladeComponent } from './components/service-blade/service-blade.component';
import { ServiceEntryComponent } from './components/service-entry/service-entry.component';
import { ChangeEntryComponent } from '@experience/shop/shared-browse/components/change-entry/change-entry.component';
import { ProductCarouselComponent } from './components/product-carousel/product-carousel.component';
import { PlanFamilyComponent } from './components/plan-family/plan-family.component';
import { EipPriceComponent } from './components/eip-price/eip-price.component';
import { FrpPriceComponent } from './components/frp-price/frp-price.component';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { SerachProductPriceComponent } from './components/search-product-price/search-product-price.component';

// Services and Routes
import { SharedBrowseService } from '@experience/shop/shared-browse/services/shared-browse.service';
import { ServicesBladeService } from '@experience/shop/shared-browse/services/services-blade.service';
import { AccessoriesService } from '@experience/shop/shared-browse/services/accessories-carousel.service';
import { PurchasePathService } from '@experience/shop/services/purchase-path.service';
import { PdpProductPriceComponent } from './components/pdp-product-price/pdp-product-price.component';
import { DeviceErrorModalComponent } from '@experience/shop/shared-browse/components/device-error-modal/device-error-modal.component';
import { NoPlanNeededComponent } from '@experience/shop/shared-browse/components/no-plan-needed/no-plan-needed.component';
import { BrowseHardgoodComponent } from '@experience/shop/hardgoods/components/browse-hardgood/browse-hardgood.component';
import { HardgoodsFilterSortComponent } from '@experience/shop/hardgoods/components/hardgoods-filter-sort/hardgoods-filter-sort.component';
import { DevicePricingPanelComponent } from '@experience/shop/hardgoods/components/pricing-pannel-component/device-pricing-panel.component';
import { CreditCheckService } from '@experience/shop/credit-check/services/credit-check.service';
// reb pdl
import { PdlModule } from '@experience/reb-pdl/pdl.module';
import { InjectablePDLService } from '@experience/reb-pdl/services/injectablepdl.service';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';
import { RetailBrowsePlansComponent } from './components/retail-browse-plans/retail-browse-plans.component';
import { RetailBrowseHardgoodComponent } from '@experience/shop/hardgoods/components/retail-browse-hardgood/retail-browse-hardgood.component';
import { RetailBrowseHardgoodDetailsComponent } from '@experience/shop/hardgoods/components/retail-browse-hardgood-details/retail-browse-hardgood-details.component';
import { DeviceSpecificationsModalComponent } from '@experience/shop/hardgoods/components/device-specifications-modal/device-specifications-modal.component';
import { CryptoSignatureService } from '@support/shared/services/crypto-signature.service';
import { UnlimitedDataPlansComponent } from '@experience/shop/shared-browse/components/plan-family-digital/unlimited-data-plans/unlimited-data-plans.component';
import { DataOnlyPlansComponent } from '@experience/shop/shared-browse/components/plan-family-digital/data-only-plans/data-only-plans.component';
import { LimitedDataPlansComponent } from '@experience/shop/shared-browse/components/plan-family-digital/limited-data-plans/limited-data-plans.component';
import { PurchaseDeviceOnlyComponent } from './components/purchase-device-only/purchase-device-only.component';
import { PlanSubTitleComponent } from '@experience/shop/shared-browse/components/plan-sub-title/plan-sub-title.component';
import { PlanPromotionHeaderComponent } from '@experience/shop/shared-browse/components/plan-promotion-header/plan-promotion-header.component';
import { AutopayDiscountComponent } from './components/autopay-discount/autopay-discount.component';

@NgModule({
  exports: [
    PlanPromotionHeaderComponent,
    ChangeEntryComponent,
    AutopayDiscountComponent,
    ProductCarouselComponent,
    ServiceBladeComponent,
    PlanFamilyComponent,
    EipPriceComponent,
    FrpPriceComponent,
    ProductPriceComponent,
    SerachProductPriceComponent,
    PdpProductPriceComponent,
    DeviceErrorModalComponent,
    NoPlanNeededComponent,
    BrowseHardgoodComponent,
    RetailBrowseHardgoodComponent,
    RetailBrowseHardgoodDetailsComponent,
    DeviceSpecificationsModalComponent,
    HardgoodsFilterSortComponent,
    DevicePricingPanelComponent,
    RetailBrowsePlansComponent,
    UnlimitedDataPlansComponent,
    LimitedDataPlansComponent,
    DataOnlyPlansComponent,
    PurchaseDeviceOnlyComponent,
    PlanSubTitleComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetsModule,
    RouterModule,
    PdlModule.forChild(),
  ],
  declarations: [
    ChangeEntryComponent,
    ProductCarouselComponent,
    ServiceBladeComponent,
    ServiceEntryComponent,
    PlanFamilyComponent,
    EipPriceComponent,
    FrpPriceComponent,
    ProductPriceComponent,
    SerachProductPriceComponent,
    PdpProductPriceComponent,
    DeviceErrorModalComponent,
    NoPlanNeededComponent,
    BrowseHardgoodComponent,
    RetailBrowseHardgoodComponent,
    RetailBrowseHardgoodDetailsComponent,
    DeviceSpecificationsModalComponent,
    HardgoodsFilterSortComponent,
    DevicePricingPanelComponent,
    RetailBrowsePlansComponent,
    UnlimitedDataPlansComponent,
    LimitedDataPlansComponent,
    DataOnlyPlansComponent,
    PurchaseDeviceOnlyComponent,
    PlanPromotionHeaderComponent,
    AutopayDiscountComponent,
    PlanSubTitleComponent,
  ],
  providers: [
    SharedBrowseService,
    AccessoriesService,
    ServicesBladeService,
    PurchasePathService,
    CreditCheckService,
    CryptoSignatureService,
    PdlWrapperService,
    InjectablePDLService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedBrowseModule {}
